import './dev-settings.scss';
import {observer} from "mobx-react";
import React, {useEffect} from "react";
import EditorPageLayout from "../../components/layouts/editor-page/editor-page-layout";
import ListLayout from "../../components/layouts/list-layout/list-layout";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import Card from "../../components/layouts/card/card";
import {FormFieldLine} from "../../components/form-field-line/form-field-line";
import {Button} from "../../components/inputs/button/button";
import {BUTTON_VARIANTS} from "../../components/inputs/button-variants";
import devBillingSettingsStore from "./stores/dev-billing-settings-store";
import DateRangePickerV2, {DatePickerVariant, IDateRangeISO} from "../../components/date-range-picker-v2/date-range-picker-v2";

const DevSettings: React.FC = observer(() => {

    useEffect(() => {
        devBillingSettingsStore.load();
    }, []);

    const saveChanges = () => {
        devBillingSettingsStore.save();
    }

    const onDevBillingDateChange = (value: IDateRangeISO | null) => {
        devBillingSettingsStore.setCurrentBillingDate(value);
    };

    const calculateBillingDateSelected = (value: IDateRangeISO | null) => {
        devBillingSettingsStore.setCalculateBillingDate(value);
    };

    const runBillingCalculation = () => {
        devBillingSettingsStore.runBillingCalculation();
    }

    return (
        <BasePageLayout
            title={'Dev Settings'}
        >
            <div className="dev-settings-page-wrapper">
                <EditorPageLayout
                    toolbar={{
                        hasLocalesSelector: false,
                        hasBack: false,
                        saveButton: {
                            hasChanges: devBillingSettingsStore.hasChanges(),
                            onClick: saveChanges,
                            disabled: !devBillingSettingsStore.hasChanges() || devBillingSettingsStore.isSaving(),
                        },
                        isLoading: devBillingSettingsStore.isLoading()
                    }}
                >
                    <ListLayout>
                        <Card
                            toolbar={{
                                title: 'Billing Settings'
                            }}
                        >
                            <FormFieldLine label={'Set fake billing date'}
                                           note={'This date will be used on rma, order tracking creation and as billing processing year and month'}>
                                <div className="form-field-line-content-wrapper">
                                    <DateRangePickerV2
                                        onChange={onDevBillingDateChange}
                                        value={devBillingSettingsStore.currentBillingDate}
                                        variant={DatePickerVariant.DATE}
                                        timeZone="UTC"
                                    />
                                </div>
                            </FormFieldLine>
                            <FormFieldLine label={'Calculate billing'} note={''}>
                                <div className="form-field-line-content-wrapper">
                                    <DateRangePickerV2
                                        value={devBillingSettingsStore.calculateBillingDate}
                                        onChange={calculateBillingDateSelected}
                                        variant={DatePickerVariant.DATE}
                                        timeZone="UTC"
                                    />
                                    <Button isLoading={devBillingSettingsStore.isCalculating()}
                                        hasLoader={true}
                                        variant={BUTTON_VARIANTS.Secondary}
                                        text={'Run calculation'}
                                        disabled={
                                            devBillingSettingsStore.isCalculating()
                                            || devBillingSettingsStore.isLoading()
                                            || devBillingSettingsStore.isSaving()
                                        }
                                        onClick={runBillingCalculation}
                                    />
                                </div>
                            </FormFieldLine>
                        </Card>
                    </ListLayout>
                </EditorPageLayout>
            </div>
        </BasePageLayout>
    );
});

export default DevSettings;
